<template>
  <div class="scroller">
    <div class="resource">
      <h2 class="resource__heading" v-if="action === 'create'">New user</h2>
      <h2 class="resource__heading" v-else>Edit user</h2>

      <form class="form" @submit.prevent="onSubmit">
        <div class="form__row mb2">
          <div class="grid">
            <div class="grid__column--six">
              <div class="form__group">
                <label class="form__label" for="name">First name:</label>
                <input
                  type="text" id="name" name="name"
                  class="form__input"
                  v-model="user.name"
                />
              </div>
            </div>
            <div class="grid__column--six">
              <div class="form__group">
                <label class="form__label" for="email">Email:</label>
                <span class="form__error" v-if="errors.has('email')">{{ errors.first('email') }}</span>
                <input
                  type="text" id="email" email="email"
                  class="form__input" :class="{ 'form__input--error': errors.has('email') }"
                  v-validate="{ required: true }"
                  v-model="user.email"
                />
              </div>
            </div>
            <div class="grid__column--six">
              <div class="form__group">
                <label class="form__label" for="surname">Last name:</label>
                <input
                  type="text" id="surname" name="surname"
                  class="form__input"
                  v-model="user.surname"
                />
              </div>
            </div>

            <div class="grid__column--six">
              <div class="form__group--url">
                <label class="form__label" for="url">Url:</label>
                <span class="form__error" v-if="errors.has('url')">{{ errors.first('url') }}</span>
                <input
                  type="text" id="url" name="url" ref="url"
                  class="form__input" :class="{ 'form__input--error': errors.has('url') }"
                  v-validate="{ required: true }"
                  :value="user.url"
                  @input="slugifyOnTyping($event.target.value)"
                />
              </div>
            </div>

            <div class="grid__column--six">
              <div class="form__group">
                <label class="form__label" for="role">Role:</label>
                <select
                  type="text" id="role" name="role"
                  class="form__input"
                  v-model="user.role"
                >
                  <option :value="role" v-for="role in roles" :key="role.id">{{ role.name }}</option>
                </select>
              </div>
            </div>
            <div class="grid__column--six">
              <div class="form__group">
                <label class="form__label" for="title">Title:</label>
                <input
                  type="text" id="title" name="title"
                  class="form__input"
                  v-model="user.title"
                />
              </div>
            </div>
            <div class="grid__column--six" v-if="user.additionals">
              <div class="form__group">
                <label class="form__label" for="additionalsTwitter">Twitter:</label>
                <input
                  type="text" id="additionalsTwitter" name="additionalsTwitter"
                  class="form__input"
                  v-model="user.additionals.twitter"
                />
              </div>
            </div>
            <div class="grid__column--six" v-if="user.additionals">
              <div class="form__group">
                <label class="form__label" for="additionalsFacebook">Facebook:</label>
                <input
                  type="text" id="additionalsFacebook" name="additionalsFacebook"
                  class="form__input"
                  v-model="user.additionals.facebook"
                />
              </div>

              <template v-if="action === 'create'">
                <div class="form__group">
                <label class="form__label" for="password">Password:</label>
                <span class="form__error" v-if="errors.has('password')">{{ errors.first('password') }}</span>
                <input
                  type="password" id="password" password="password"
                  class="form__input" :class="{ 'form__input--error': errors.has('password') }"
                  v-validate="{ required: true }"
                  v-model="user.password"
                />
              </div>
              </template>
            </div>
            <div class="grid__column--six">
              <div class="form__group">
                <div class="form__group">
                  <UploadImage :image.sync="user.media"/>
                </div>
              </div>
            </div>
          </div>

          <div class="form__group">
              <button type="submit" class="btn btn--primary btn--nextToInput" v-if="action === 'create'">PUBLISH</button>
              <button type="submit" class="btn btn--primary btn--nextToInput" v-else>UPDATE</button>
            </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import User from '@/model/User'
import { slugifyString, submitResource } from '@/helpers/handleForm.js'
import UploadImage from '@/components/Utils/UploadImage'

export default {
  components: {
    User, UploadImage
  },
  props: {
    action: {
      type: String,
      default: 'edit'
    },
    user: {
      type: Object,
      default () {
        return {
          additionals: {},
          blocks: []
        }
      }
    }
  },
  data () {
    return {
      roles: [
        {
          id: 1,
          name: 'Admin'
        }, {
          id: 2,
          name: 'Editor'
        }
      ]
    }
  },
  methods: {
    onSubmit () {
      submitResource(this.$validator, User, this.user, this.action)
    },
    slugifyOnTyping (value) {
      this.user.url = slugifyString(value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User/UserForm.vue